import axios from "axios";

// 1. Define Base URL
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_PROD_URL || "http://localhost:8080";

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true, // Sends cookies
  headers: { 'Content-Type': 'application/json' }
});

// --- Request Interceptor ---
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('jwtToken') || localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// --- Response Interceptor ---
api.interceptors.response.use(
  (response) => {
      return response;
  },
  (error) => {
    // Log error for debugging
    if (error.response) {
        console.error(`[API Error] ${error.config.url} - Status: ${error.response.status}`, error.response.data);
    }

    // ✅ FIX 1: Only Logout on 401 (Token Invalid/Expired)
    if (error.response && error.response.status === 401) {
      const isLoginRequest = error.config && error.config.url.includes("/auth/login");
      if (!isLoginRequest) {
          console.warn("⚠️ Token Expired (401). Logging out.");
          localStorage.clear();
          if (window.location.pathname !== "/login") {
              window.location.href = '/login'; 
          }
      }
    }

    // ✅ FIX 2: On 403 (Permission Denied), DO NOT LOGOUT.
    // Just reject the promise so the component can show a red Toast.
    if (error.response && error.response.status === 403) {
        console.warn("⚠️ Access Denied (403). Session remains active.");
    }
    
    return Promise.reject(error);
  }
);

// --- API Exports ---
export const getAuditLogs = () => api.get("/vres/audit/logs");
export const getUserDetailsById = (userId) => api.get(`/vres/users/${userId}`);
export const updateUserDetails = (userId, userData) => api.put(`/vres/users/${userId}`, userData);
export const loginUser = (credentials) => api.post("/vres/auth/login", credentials);
export const getCaptcha = () => api.get("/vres/auth/captcha");
export const getProjects = () => api.get("/vres/projects/my-projects");

// Helper for uploads
export const uploadBeneficiaries = (projectId, formData, params) => {
    return api.post(`/vres/projects/${projectId}/beneficiaries/upload`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        params: params 
    });
};

export default api;